import React, { createContext, useContext, useState } from "react";

const AsOfDateModeContext = createContext({
	isAsOfDateMode: false,
	setIsAsOfDateMode: () => {},
});

const getInitialAsOfDateMode = () => {
	try {
		const url = new URL(window.location.hash.slice(1), window.location.origin);
		const filter = JSON.parse(url.searchParams.get("filter") || "{}");
		return filter.is_as_of_date_mode === true;
	} catch (e) {
		return false;
	}
};

// TODO: Consider using getInitialAsOfDateMode directly instead of AsOfDateModeProvider
export const AsOfDateModeProvider = ({ children }) => {
	const [isAsOfDateMode, setIsAsOfDateMode] = useState(getInitialAsOfDateMode);

	return (
		<AsOfDateModeContext.Provider value={{ isAsOfDateMode, setIsAsOfDateMode }}>
			{children}
		</AsOfDateModeContext.Provider>
	);
};

export const useAsOfDateMode = () => useContext(AsOfDateModeContext);
